import MultiDark from "../../../../contents/images/tutorials/hogql-breakdowns/multi-dark.png";
import MultiLight from "../../../../contents/images/tutorials/hogql-breakdowns/multi-light.png";
import * as React from 'react';
export default {
  MultiDark,
  MultiLight,
  React
};